
import http from '@/base/api/public'
import querystring from 'querystring'
let apiUrl = require('@/../config/sysConfig')

// パスワードリセット
export const passwordReset = (params) => {
    let querys = querystring.stringify(params)
    return http.requestGet(apiUrl.apiUrl_PwReset + '?' + querys)
}
//loginCheck
export const login_check = (userCd, verCode) => {
    return http.requestPost(apiUrl.apiUrl_TempCode + '?userCd=' + userCd + '&verCode=' + verCode)
}


// WEBPACK FOOTER //
// ./src/components/api/passwordResetDeliver.js